import { RouteRecordRaw } from "vue-router";
import { t } from "@/core/i18n";

export const route: RouteRecordRaw = {
  path: "/books",
  name: "books",
  redirect: { name: "BooksList" },
  children: [
    {
      path: "list",
      name: "BooksList",
      component: () => import("./screens/BooksList.vue"),
      meta: {
        breadcrumb: [
          { title: t("books"), routeName: "books" },
          { title: t("manage-books"), routeName: "BooksList" },
        ],
      },
    },
    {
      path: "create",
      name: "CreateBook",
      component: () => import("./screens/BookForm.vue"),
      meta: {
        breadcrumb: [
          { title: t("books"), routeName: "books" },
          { title: t("manage-books"), routeName: "BooksList" },
          { title: t("add-book"), routeName: "CreateBook" },
        ],
      },
    },
    {
      path: "import",
      name: "ImportBooks",
      component: () => import("./screens/ImportBooks.vue"),
      meta: {
        breadcrumb: [
          { title: t("books"), routeName: "books" },
          { title: t("manage-books"), routeName: "BooksList" },
          { title: t("import-books"), routeName: "ImportBooks" },
        ],
      },
    },
    {
      path: ":id/view",
      name: "ViewBook",
      component: () => import("./screens/BookViewer.vue"),
      meta: {
        breadcrumb: [
          { title: t("books"), routeName: "books" },
          { title: t("manage-books"), routeName: "BooksList" },
          { title: t("view-book"), routeName: "ViewBook" },
        ],
      },
    },
    {
      path: ":id/edit",
      name: "UpdateBook",
      component: () => import("./screens/BookForm.vue"),
      meta: {
        breadcrumb: [
          { title: t("books"), routeName: "books" },
          { title: t("manage-books"), routeName: "BooksList" },
          { title: t("edit-book"), routeName: "UpdateBook" },
        ],
      },
    },
  ],
};
